import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { endSession, getClientToken, getPlayerBalanceSuccess, logout, playerDataReset, setMyBetsCount } from "../actions/UserActions";
import { Auth } from "../services/Auth";
import { checkRussianVerificationStatusesV2, checkRussianVerificationV2StatusesSuccess } from "../actions/account/AccountAction";
import config from "../constants/Configs";
import { getReachLimit, getSettingsSuccess, getUnverifiedUserReminder } from "../actions/settings/SettingsAction";
import SiteEvent from '../services/events/SiteEvent';
import { changePopupVisibility } from "../actions/ControlsAction";
import PopupEnum from "./base/PopupEnum";
import { CupisClientStatusEnumV2 } from "./myProfile/CupisStatusesEnum";
// import SportHelper from "../services/helpers/sport/SportHelper";
// import { SportDispatchingEventType } from "../services/helpers/sport/enums/SportEventType";
import { getClientUnreadMessagesCountSuccess } from "../actions/MessagesAction";
import { setNewBonusCount } from "../actions/profile/BonusActions";
import { LanguageService } from "../services/LanguageService";

const WS_OPEN_STATE = 1;
const RECONNECT_TIME = 15000;
const RETRY_COUNT = 15;
const PING_TIME = config.NEW_PLAT ? 5000 : 50000;
const WebSoketSubType =
{
    None: 0,
    /// <summary>
    /// Indicates a subscription to maintenance events. Clients subscribing to this type
    /// will receive notifications related to system maintenance activities,
    /// such as scheduled downtimes or updates.
    /// </summary>
    Maintenance: 1 << 0,//1

    /// <summary>
    /// Indicates a subscription to Cupis events. Clients subscribing to this type
    /// will receive notifications specific to Cupis operations or updates.
    /// The exact nature of these events would depend on the context of the application's
    /// integration with the Cupis system.
    /// </summary>
    UserEvents: 1 << 1,//2
    //
    // Continue for other events, each with a unique bit position
}

export default function useWebsocket() {
    const dispatch = useDispatch();
    const timeOutRef = useRef(null);
    const ws = useRef(null);
    const balanceTimeStampRef = useRef(null);
    const retries = useRef(0);
    const [isWsOpen, setWsOpen] = useState(false);
    const { playerData = {} } = useSelector(state => state.user);
    const player = playerData.player;
    const socketHost = config.NEW_PLAT ? config.WS_DOMAIN : useSelector(state => state.settings.socketHost)
    const partnerId = useSelector(state => state.settings.partnerId)
    const projectId = useSelector(state => state.settings.projectId)
    const lang = LanguageService.getSelectedLanguage() || LanguageService.getSelectedLanguageFromLocalStorage();
    const isNewBonuses = useSelector(state => state.settings.isBonusVersion2Enabled);
    
    function authenticate(token) {
        let command = {
            command: "subscribe",
            action: "UserEvents",
            data: {
                "Token": token,
                "ClientId": player?.id
            }
        };
        ws.current?.send(JSON.stringify(command));
    }

    function authenticateNewPlat(commandModel) {


        var commandString = JSON.stringify(commandModel);
        var encoder = new TextEncoder();
        var byteArray = encoder.encode(commandString);
        ws.current?.send(byteArray);
    }

    function recieceMessageNewPlat(message) {
        if (!message) return;
        const data = message.Data;
        switch (message.Event) {
            case "Maintenance":
                dispatch(getSettingsSuccess({ isUnderMaintenance: data?.IsActive }));
                return;

            case "DepositSuccess":
                SiteEvent.dispatchEvent(SiteEvent.category.Deposit, SiteEvent.action.Success, data);
                return;
            case "DepositError":
                SiteEvent.dispatchEvent(SiteEvent.category.Deposit, SiteEvent.action.Error, data);
                return;
            case "WithdrawalSuccess":
                SiteEvent.dispatchEvent(SiteEvent.category.Withdrawal, SiteEvent.action.Success, data);
                return;
            case "WithdrawalError":
                SiteEvent.dispatchEvent(SiteEvent.category.Withdrawal, SiteEvent.Error, data);
                return;
            case "CasinoBetSuccess":
                SiteEvent.dispatchEvent('casino-bet', SiteEvent.action.Success, data);
                return;
            case "Authorization":
                // authenticateNewPlat({ 
                //     "Command": "GetAllSubscriptions"
                // })
                authenticateNewPlat({
                    "Command": "Subscribe",
                    "Action": "LimitWarning"
                })
                authenticateNewPlat({
                    "Command": "Subscribe",
                    "Action": "SportOpenBets"
                })
                return;
            case "LimitWarning":
                dispatch(getReachLimit({ reachLimitData: data, isReachLimitPopupOpen: true }));
                return;
            case "BlockForUnverifiedReminder":
                dispatch(getUnverifiedUserReminder({ isUnverifiedUserReminderOpen: true }))
            case "BalanceChange":
                if (data.TimeStamp > balanceTimeStampRef.current && (config.ENV === 'prod-cnt-prdeu' || config.ENV === 'tst-cnt')) {
                    dispatch(getPlayerBalanceSuccess({ data: isNewBonuses ? { availableBalance: data.Balance } : { realBalance: data.Balance }, isNewBonuses }));
                    balanceTimeStampRef.current = data.TimeStamp;
                }
                return;
            case "BonusCounts":
                // SportHelper.dispatchEvent(SportDispatchingEventType.UpdateFreeBet);
                // "ActiveCount": 5,
                // NewCount: 2
                dispatch(setNewBonusCount(data?.Count));
                return;
            case "Pong":
                if (Auth.isAuthenticated() && !data?.IsAuthorized && config.ENV === 'prod-cnt-prdeu') {
                    endSession(true, true);
                    dispatch(logout());
                    dispatch(playerDataReset());
                }
                return;
            case "InboxNotification":
                dispatch(getClientUnreadMessagesCountSuccess(data?.Count));
                // data?.Message
                return;
            case "SportOpenBets":
                dispatch(setMyBetsCount(data?.OpenBetCount));
                return;
        }
    }

    function recieceMessage(message) {
        if (!message) return;
        const { data } = message;

        switch (message.sub) {
            case WebSoketSubType.UserEvents:
                switch (message.event) {
                    case "Cupis":
                        // document.dispatchEvent(new CustomEvent('cupis-status-change', { detail: data?.ShowIdentificationForm }))
                        dispatch(checkRussianVerificationStatusesV2(true))

                        // We can we open our popup via custom script by throwing custom event
                        if (data?.StatusId === CupisClientStatusEnumV2.RegisteredSimple || data?.StatusId === CupisClientStatusEnumV2.RegisteredFull) {
                            dispatch(changePopupVisibility({ visibility: true, selectedTab: PopupEnum.Cashier }));
                        }
                        // dispatch(checkRussianVerificationV2StatusesSuccess(
                        //     {
                        //         State: data?.statusId,
                        //         NotificationText: data?.notificationText,
                        //         AlternativNotificationText: data?.alternativNotificationText,
                        //         ShowIdentificationForm: data?.ShowIdentificationForm
                        //     }
                        // ));
                        return;
                }
                return;
            case WebSoketSubType.Maintenance:
                dispatch(getSettingsSuccess({ isUnderMaintenance: data?.isActive }));
                return;
        }
    }

    function connectWebSocket() {
        if (!socketHost || retries.current > RETRY_COUNT) {
            return;
        }
        ws.current = new WebSocket(`wss://${socketHost}?${config.NEW_PLAT ? `brandId=${projectId}` : `partnerId=${partnerId}`}`);
        ws.current.onopen = () => {
            setWsOpen(true)
            retries.current = 0;
        }
        ws.current.onclose = (e) => {
            setWsOpen(false)
            // if (e.code === 1000) {
            //     connectWebSocket();
            //     return;
            // }
            if (timeOutRef.current) {
                clearTimeout(timeOutRef.current);
                timeOutRef.current = null
            }
            timeOutRef.current = setTimeout(connectWebSocket, RECONNECT_TIME);
        }
        ws.current.onerror = evt => console.log(evt)
        const wsCurrent = ws.current;
        ws.current.onmessage = e => {
            const message = JSON.parse(e.data);
            config.NEW_PLAT ? recieceMessageNewPlat(message) : recieceMessage(message);
        };
        retries.current = retries.current + 1;
        return () => {
            wsCurrent.close();
        };

    }
    useEffect(() => {
        connectWebSocket()
    }, [socketHost]);

    useEffect(() => {
        if (ws.current?.readyState === WS_OPEN_STATE) {
            ws.current?.send(config.NEW_PLAT ? "{\"Command\":\"Settings\",\"Data\":{\"LangCode\" : " + `"${LanguageService.getSelectedLanguage()}"` + "}" + "}" : JSON.stringify({
                    command: "settings"
                }));

        }
    }, [ws.current?.readyState, lang]);

    useEffect(() => {
        let intervalId = null;
        if (ws.current?.readyState === WS_OPEN_STATE) {
            if (Auth.isAuthenticated() && player?.id) {
                if (config.NEW_PLAT) {

                    authenticateNewPlat({
                        "Command": "Authorization",
                        "Data": `Bearer ${Auth.getAccessToken()}`
                    });

                } else {
                    dispatch(getClientToken()).then((token) => {
                        authenticate(token)
                    })
                }

            }

            intervalId = setInterval(() => {
                let command = {
                    command: "ping"
                };
                ws.current?.send(config.NEW_PLAT ? "{\"Command\":\"Ping\" " + (Auth.isAuthenticated() ? ", \"Data\": \"Bearer " + Auth.getAccessToken() + "\"" : "") + "}" : JSON.stringify(command));
            }, PING_TIME)
        }
        return () => intervalId && clearInterval(intervalId);
    }, [ws.current?.readyState, Auth.isAuthenticated(), player?.id]);

    return;
}

